import { IFilter } from "@saleor/components/Filter";
import { commonMessages } from "@saleor/intl";
import { FilterOpts } from "@saleor/types";
import { createBooleanField } from "@saleor/utils/filters/fields";
import { defineMessages, IntlShape } from "react-intl";

export enum RotaryFilterKeys {
  isEnable = "isEnable"
}
export interface RotaryListFilterOpts {
  isEnable: FilterOpts<boolean>;
}

const messages = defineMessages({
  isEnable: {
    defaultMessage: "isEnable",
    description: "isEnable"
  }
});

export function createFilterStructure(
  intl: IntlShape,
  opts: RotaryListFilterOpts
): IFilter<RotaryFilterKeys> {
  return [
    {
      ...createBooleanField(
        RotaryFilterKeys.isEnable,
        intl.formatMessage(messages.isEnable),
        opts.isEnable.value,
        {
          negative: intl.formatMessage(commonMessages.no),
          positive: intl.formatMessage(commonMessages.yes)
        }
      ),
      active: opts.isEnable.active
    }
  ];
}
